import { Image, Text } from '@chakra-ui/react';
import { IoRocketOutline, IoTimerOutline } from 'react-icons/io5';
import { MdVerified } from 'react-icons/md';
import { AiOutlineSafety } from 'react-icons/ai';

import certGif from './cert.gif';
import './Section3.css';

function Section3() {
  const features = [
    {
      icon: IoRocketOutline,
      title: 'Fast Document Setup',
      text: 'Upload your template once and generate verified documents instantly.',
    },
    {
      icon: MdVerified,
      title: 'Universal Verification',
      text: 'Any document type can be verified online securely and instantly.',
    },
    {
      icon: AiOutlineSafety,
      title: 'Tamper-Proof & Secure',
      text: 'Documents are protected with security layers to prevent misuse.',
    },
    {
      icon: IoTimerOutline,
      title: 'Available 24/7',
      text: 'Documents can be accessed and verified anytime, anywhere.',
    },
  ];

  return (
    <div className="section3-wrapper">

      <div className="section3-banner">
        <Text className="section3-banner-text">
          Use our easy-to-use document generation and distribution service
        </Text>
      </div>

      <div className="section3-content">

        <div className="section3-left">
          <Image src={certGif} className="section3-gif" />
        </div>

        <div className="section3-right">
          {features.map((f, i) => (
            <div className="feature-card" key={i}>
              <div className="feature-icon">
                <f.icon size={36} color={'#377DFF'} />
              </div>
              <div>
                <h3 className="feature-title">{f.title}</h3>
                <p className="feature-text">{f.text}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default Section3;
